export default __webpack_public_path__ + "static/media/tucthan.60728803.png";